export default "__VITE_ASSET__D8d_gtx9__"